import { MtStudy } from "server/models"
import { OrderType } from "client/utils"

export interface StudyProps {
    studyId: number
}

export interface StudyList { [studyId: number]: MtStudy }
export interface StudyFilters {
    search?: string
}

export type StudyValidation = { [key in keyof MtStudy]?: string }

export interface StudyState {
    baseRoute: string

    studyList: StudyList
    studyIds: readonly number[]
    studyView: MtStudy
    studyEdit: MtStudy

    sortColumn: keyof MtStudy
    sortOrder: OrderType
    filters: StudyFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const STUDY_BASE_ROUTE = "STUDY_BASE_ROUTE"

export const STUDY_LIST = "STUDY_LIST"
export const STUDY_IDS = "STUDY_IDS"
export const STUDY_VIEW = "STUDY_VIEW"
export const STUDY_EDIT = "STUDY_EDIT"

export const STUDY_SORT = "STUDY_SORT"
export const STUDY_FILTERS = "STUDY_FILTERS"

export const STUDY_RELOAD_LIST = "STUDY_RELOAD_LIST"
export const STUDY_RELOAD_VIEW = "STUDY_RELOAD_VIEW"
export const STUDY_RELOAD_EDIT = "STUDY_RELOAD_EDIT"
